import * as constants from './constants'
import * as actions from './actions'
import selectors from './selectors'
import reducer from './reducer'
import processors from './processors'

export default {
  selectors,
  actions,
  constants,
  reducer,
  processors,
  namespace: constants.namespace
}
